<template>
  <v-flex class=" lg8 md10 sm12"  >
    <h1>Acknowledgements</h1>
     <v-layout column class="text-xs-left ml-2" >
       <div>
         We would like to acknowledge and thank the authors of the following tools
         and resources which are used within the Smart Kids Market site.
       </div>
       <div>
         <a href="https://vuejs.org/">Vue.js</a> : The progressive Javascript Framework.
       </div>
       <div>
         <a href="https://vuetifyjs.com/">Vuetify</a> component library.
       </div>
       <div>
         <a href="https://icons8.com/">Icons8</a> icons were used to make sure the site looks good!
       </div>
       <div>
         Many public domain images were found and used from <a href="https://www.pexels.com">Pexels</a>
       </div>
     </v-layout>
     <hr />

     <div class="text-xs-left">
       <v-btn round class="secondary" @click="$router.go(-1)">
         <v-icon left dark>{{$vuetify.icons.back}}</v-icon>
         Back
       </v-btn>
     </div>

</v-flex>

</template>

<script>
// import {mapState} from 'vuex'

export default {
  name: 'Acknowledgements',
  data () {
    return {
    }
  },
}
</script>
